/** @format */

// Mounts SupportBox on every page built on layouts/app_tw.html. It gets a root
// of its own rather than joining the page's app because /plans is prerendered
// and hydrated: anything added to that tree would not match the server's
// markup.
import React from 'react'
import {createRoot} from 'react-dom/client'

import SupportBox from './SupportBox'

const container = document.createElement('div')
container.id = 'support-box'
document.body.appendChild(container)
createRoot(container).render(<SupportBox />)
